import { render, staticRenderFns } from "./IndexAdmin.vue?vue&type=template&id=3b20a5cc&scoped=true"
import script from "./IndexAdmin.vue?vue&type=script&lang=js"
export * from "./IndexAdmin.vue?vue&type=script&lang=js"
import style1 from "./IndexAdmin.vue?vue&type=style&index=1&id=3b20a5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b20a5cc",
  null
  
)

export default component.exports